import { Button, Modal, Spin, Upload } from "antd";
import { LoadingOutlined } from '@ant-design/icons';
import React from "react";
// import "./TermDateUpdate.css";
import "../../GlobalCss/SPF/TermDateUpdate.css";
import { useState } from "react";
import { GenerateTermDateTemplateExcel } from "../../Helpers/TermDateUpdateHelper";
import { FetchTermDateTemplateHeaders, PostTermDateFile } from "../../Repository/UtilitiesPageRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../../Utils/Utils";

const TerminationDateUpdate = () => {

    //State Variables
    const [ShowTermDateModal, setShowTermDateModal] = useState(false);
    const [UploadedFilesList, setUploadedFilesList] = useState([]);
    const [FileListStatus, setFileListStatus] = useState("");
    const [Uploading, setUploading] = useState(false);


    //Handling default term date excel template download request
    const HandleTermDateTemplateAction = async () => {
        let TemplateHeaders;
        try {
            let Response = await FetchTermDateTemplateHeaders();
            if (Response != null) {
                if (Response.StatusCode === 200) {
                    TemplateHeaders = JSON.parse(Response.Payload);
                }
                else {
                    ErrorMessage(Response.Payload);
                    TemplateHeaders = null;
                }
            }

            if (TemplateHeaders !== null || TemplateHeaders !== undefined) {
                GenerateTermDateTemplateExcel(TemplateHeaders);
            }
        }
        catch (error) {
            ErrorMessage("Unable to resolve request, please try again");
        }

    }

    // Handling when user uploads term date excel with data for paychex master
    const HandleTermDateUploadAction = async (options) => {
        const { file } = options;
        setUploadedFilesList([file]);
        setFileListStatus("loading")
        setUploading(true);

        //Check file extension
        if (file && (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")) {
            ErrorMessage("Please upload only .xlsx files.");
            setFileListStatus("error")
            setUploading(false);
            return;
        }

        //Making Http Request for Term date upload
        let formData = new FormData();
        formData.append("file", file);
        const PostStatus = await PostTermDateFile(formData);

        if(PostStatus != null){
            if (PostStatus.StatusCode === 200) {
                SuccessMessage(PostStatus.Message);
                setFileListStatus("success")
            }
            else if(PostStatus.StatusCode === 204){
                InfoMessage(PostStatus.Message);
                setFileListStatus("loading")
            }
            else {
                ErrorMessage(PostStatus.Message);
                setFileListStatus("error")
            }
        }
        else{
            setFileListStatus("error")
        }
        //setting loading symbol state when uploading
        setUploading(false);
    }

    return (
       
                <div className="term-date-upload-elements">
                    <Button className="term-date-button" onClick={() => HandleTermDateTemplateAction()}>TermDate Template</Button>
                    <div className="term-date-upload">
                        <Upload.Dragger
                            accept=".xlsx"
                            customRequest={HandleTermDateUploadAction}
                            fileList={UploadedFilesList}
                            onRemove={() => setUploadedFilesList([])}
                            className={`term-date-upload-${FileListStatus}`}
                        >Upload TermDate File</Upload.Dragger>
                    </div>
                    {Uploading?<Spin indicator={<LoadingOutlined/>} className="term-date-upload-spinner"/>:<></>}
                </div>
           
      
    )
}

export default TerminationDateUpdate;